import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiSunrunComparisonTableContainer' })(
  ({ breakpoints, brandColors, typography }) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      background: `linear-gradient(180deg, ${brandColors.offWhite}  10%, ${brandColors.tintsChargeBlue50} 90%)`,
      padding: typography.pxToRem(80),
      [breakpoints.down(ScreenSize.LARGE)]: {
        fontSize: typography.pxToRem(64),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        padding: 0,
      },
      [breakpoints.down(ScreenSize.SMALL)]: {
        padding: 0,
      },
    },
    heading: {
      width: '100%',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontSize: typography.pxToRem(24),
        padding: `${typography.pxToRem(40)}`,
      },
      [breakpoints.down(ScreenSize.SMALL)]: {
        fontSize: typography.pxToRem(32),
        marginBottom: typography.pxToRem(14),
        padding: `${typography.pxToRem(40)} ${typography.pxToRem(24)}`,
      },
    },
    title: {
      width: '100%',
      fontSize: typography.pxToRem(44),
      fontWeight: 500,
      marginBottom: typography.pxToRem(24),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontSize: typography.pxToRem(24),
        marginBottom: typography.pxToRem(14),
      },
      [breakpoints.down(ScreenSize.SMALL)]: {
        fontSize: typography.pxToRem(32),
        marginBottom: typography.pxToRem(14),
      },
    },
    subtitle: {
      width: '100%',
      fontSize: typography.pxToRem(20),
      marginBottom: typography.pxToRem(58),
      fontWeight: 400,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        margin: 0,
        maxWidth: typography.pxToRem(296),
        marginBottom: typography.pxToRem(0),
      },
      [breakpoints.down(ScreenSize.SMALL)]: {
        fontSize: typography.pxToRem(18),
        margin: 0,
        maxWidth: '80%',
        marginBottom: typography.pxToRem(0),
      },
    },
    tables: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      width: '100%',
    },
  })
);

export default useStyles;
